var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/video-msg-item.html');
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');
var util = require('./../../global/utils');
var config = require('./../../global/config');
var platform = require('../../../lib/platform');
var fileHandler = require('../../../lib/fileHandler');

var updateVideoInfo = function () {
  var self = this;
  // 视频预览图大小''
  var msgcontent = self._data.msg.content;
  var fitSarari = platform.name.indexOf('Safari') !== -1;

  var renderImage = function (options) {
    var imgParams = util.getImgParams(options);
    var $content = self._element.find('.im-msg-content');
    $content.css({
      'height': imgParams.height + 'px',
      'width': imgParams.width + 'px',
      'background-size': imgParams.background_size,
      'background-image': 'url(' + imgParams.url + ')',
      'background-repeat': 'no-repeat'
    });
  };

  // if(fitSarari){
  //   fileHandler.createThumbnail(msgcontent.url, function (thumbnailObj) {
  //     var options = {
  //       minsize: 50,
  //       maxsize: 250,
  //       image_width: thumbnailObj.width,
  //       image_height: thumbnailObj.height,
  //       url: thumbnailObj.duration ? thumbnailObj.data : config['default-card-img']
  //     };
  //     renderImage(options);
  //   });
  // }else{
  var options = {
    minsize: 50,
    maxsize: 250,
    image_width: msgcontent.thumbnail_width,
    image_height: msgcontent.thumbnail_height,
    url: (!msgcontent.thumbnail_url || msgcontent.thumbnail_url.indexOf('data:') !== -1 || !msgcontent.thumbnail_url.indexOf('//') === -1) ? config['default-card-img'] : msgcontent.thumbnail_url
  };
  if (fitSarari) {
    var setThumbnailUrl = function (thumbnail_url) {
      if (thumbnail_url && thumbnail_url.length > 1 && msgcontent.thumbnail_url.indexOf('.mp4') == -1) {
        options.url = msgcontent.thumbnail_url;
      } else {
        options.url = config['default-card-img'];
      }
    }
    var thumbnail_url = msgcontent.thumbnail_url;
    if (msgcontent.thumbnail_url && msgcontent.thumbnail_url.indexOf('data:') > -1) {
      thumbnail_url = msgcontent.thumbnail_url.replace('data:', '');
    }
    setThumbnailUrl(thumbnail_url);
  }
  renderImage(options);
  // }
};

var VideoMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;

};
VideoMsgItem.prototype = Object.create(BaseMsgItem.prototype);
VideoMsgItem.prototype.renderContent = function () {
  var self = this;
  var msg = self._data.msg;
  var $videoPlayBtn = self._element.find('.im-msg-video-btn');
  $videoPlayBtn.click(function () {
    dispatcher.dispatch({
      type: ActionType.VIDEO_PLAY,
      data: msg
    });
  });

  this.update();

};
VideoMsgItem.prototype.update = function () {
  updateVideoInfo.call(this);
};

module.exports = VideoMsgItem;
